import house from './assets/house.svg';
import person from './assets/person.svg';
import building from './assets/building.svg';
import diagram from './assets/diagram.svg';
import heart from './assets/heart.svg';
import star from './assets/star.svg';

export const ITEMS = [
  {
    id: 1,
    image: house,
    title: '1,5 млн',
    description: 'кв. м. недвижимости продается на Циан ежегодно',
  },
  {
    id: 2,
    image: person,
    title: '20 млн',
    description: 'уникальных пользователей в месяц',
  },
  {
    id: 3,
    image: building,
    title: '2 млн',
    description: 'объявлений о продаже и аренде недвижимости',
  },
  {
    id: 4,
    image: diagram,
    title: '8 из 10',
    description: 'человек в 2026 году выберут и купят квартиру на Циан',
  },
  {
    id: 5,
    image: heart,
    title: 'Топ 15',
    description: 'лучших сайтов по недвижимости в мире по версии SimilarWeb',
  },
  {
    id: 6,
    image: star,
    title: '11 лет',
    description: 'подряд в Топ 30 самых дорогих компаний Рунета по версии Forbes',
  },
];
